var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceBound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_19_03612"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_19_03612)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,58Q25.5,57.9507543,25.509607,57.9024549Q25.519215,57.854155,25.53806,57.808658Q25.556906,57.763161,25.584265,57.722215Q25.611625,57.681269,25.646447,57.646447Q25.681269,57.611625,25.722215,57.584265Q25.763161,57.556906,25.808658,57.53806Q25.854155,57.519215,25.9024549,57.509607Q25.9507543,57.5,26,57.5Q26.0492457,57.5,26.0975451,57.509607Q26.145845,57.519215,26.191342,57.53806Q26.236839,57.556906,26.277785,57.584265Q26.318731,57.611625,26.353553,57.646447Q26.388375,57.681269,26.415735,57.722215Q26.443094,57.763161,26.46194,57.808658Q26.480785,57.854155,26.490393,57.9024549Q26.5,57.9507543,26.5,58L26.5,89Q26.5,93.7635,29.86827,97.1317Q33.23654,100.5,38,100.5L50,100.5Q50.0492,100.5,50.0975,100.5096Q50.1458,100.5192,50.1913,100.5381Q50.2368,100.5569,50.2778,100.5843Q50.3187,100.61160000000001,50.3536,100.6464Q50.388400000000004,100.6813,50.4157,100.7222Q50.4431,100.7632,50.4619,100.8087Q50.4808,100.8541,50.4904,100.9025Q50.5,100.9508,50.5,101Q50.5,101.0492,50.4904,101.0975Q50.4808,101.14580000000001,50.4619,101.1913Q50.4431,101.2368,50.4157,101.2778Q50.388400000000004,101.3187,50.3536,101.3535Q50.3187,101.38839999999999,50.2778,101.4157Q50.2368,101.4431,50.1913,101.4619Q50.1458,101.4808,50.0975,101.4904Q50.0492,101.5,50,101.5L38,101.5Q32.82233,101.5,29.16117,97.83879999999999Q25.5,94.1777,25.5,89L25.5,58Z",
    fillRule: "evenodd",
    fill: "#5C6970",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,58.9605L34.7419,59L34.7442,57L2,56.9628L2,10.50923Q2,8.66028,3.84308,8.20839L28.9532,2.0518099999999997Q29.707,1.8669769999999999,30.354,2.2854799999999997L36.4992,6.26061Q36.9697,6.56493,36.9697,7.11027L37,26.4236L39,26.4204L38.9697,7.11027Q38.9697,5.47671,37.5855,4.58132L31.4403,0.606187Q30.0688,-0.2809600000000001,28.4769,0.10934100000000002L3.36682,6.26592Q0,7.09141,0,10.50923L0,58.9605Z",
    fillRule: "evenodd",
    fill: "#5C6970",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.076468,0.5058819999999999Q28.605315,0.587618,29.08473,0.9673876Q29.50554,1.300729,29.83317,1.819372Q30.14547,2.31373,30.32,2.89065Q30.5,3.48565,30.5,4.06055L30.5,58Q30.5,58.0492,30.49039,58.0975Q30.48078,58.1458,30.46194,58.1913Q30.44309,58.2368,30.41573,58.2778Q30.38838,58.3187,30.35355,58.3535Q30.31873,58.3884,30.27779,58.4157Q30.23684,58.4431,30.19134,58.4619Q30.14584,58.4808,30.09754,58.4904Q30.04925,58.5,30,58.5Q29.95075,58.5,29.90245,58.4904Q29.85416,58.4808,29.80866,58.4619Q29.76316,58.4431,29.72221,58.4157Q29.68127,58.3884,29.64645,58.3535Q29.61162,58.3187,29.58426,58.2778Q29.55691,58.2368,29.53806,58.1913Q29.51921,58.1458,29.50961,58.0975Q29.5,58.0492,29.5,58L29.5,4.06055Q29.5,3.16435,28.987739,2.35345Q28.501265,1.583369,27.9236636,1.494138Q27.87977,1.487358,27.83776,1.4729459999999999Q27.795749,1.458535,27.756936,1.436944Q27.718123,1.415353,27.683724,1.387259Q27.649325,1.359165,27.620416,1.325447Q27.591507,1.29173,27.568994,1.253444Q27.546481,1.2151589999999999,27.531069,1.173505Q27.515657,1.131851,27.507829,1.0881324Q27.5,1.0444139,27.5,1Q27.5,0.9507543,27.509607,0.9024549Q27.519215,0.854155,27.53806,0.808658Q27.556906,0.763161,27.584265,0.722215Q27.611625,0.681269,27.646447,0.646447Q27.681269,0.611625,27.722215,0.584265Q27.763161,0.556906,27.808658,0.53806Q27.854155,0.519215,27.9024549,0.5096069999999999Q27.9507543,0.5,28,0.5Q28.0383933,0.5,28.0763364,0.505862L28.0763664,0.5058659999999999L28.076468,0.5058819999999999Z",
    fillRule: "evenodd",
    fill: "#5C6970",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.043083,25.407726Q33,26.0948884,33,27.74155L33,59L55,59L55,32.16127Q55,30.71235,53.8737,29.96732L50.667500000000004,27.76693Q49.7883,27.18516,48.2326,26.925178Q37.70139,25.221573,36.32777,25.049367Q34.865358,24.86603,34.043083,25.407726ZM35,57L35,27.74155Q35,27.17232,35.14335,27.07788Q35.34911,26.94233,36.07899,27.033830000000002Q37.41719,27.2016,47.903,28.89782Q49.0394,29.08774,49.5359,29.41599L52.7703,31.63537Q53,31.787309999999998,53,32.16127L53,57L35,57Z",
    fillRule: "evenodd",
    fill: "#5C6970",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.999961853027344,28.5L49.999961853027344,58L48.999961853027344,58L48.999961853027344,28.5L49.999961853027344,28.5Z",
    fillRule: "evenodd",
    fill: "#5C6970",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 18,
    height: 6,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#2BA9DE",
    fill: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 31,
    width: 18,
    height: 6,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#2BA9DE",
    fill: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 42,
    width: 18,
    height: 6,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#2BA9DE",
    fill: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 39,
    width: 8,
    height: 4,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#2BA9DE",
    fill: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 48,
    width: 8,
    height: 4,
    rx: 1,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#2BA9DE",
    fill: "none",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-5.400848479553133e-8,5.400848479553133e-8,1,-0.0000039426193865210735,0.000002700424232671139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 73,
    width: 79,
    height: 56,
    rx: 6,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#5C6970",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.75355,117.3536L109.6464,91.46066Q110.0858,91.02132,110.0858,90.4Q110.0858,89.77868,109.6464,89.33933999999999L102.66069999999999,82.353554Q102.2213,81.9142137,101.6,81.9142136Q100.9787,81.9142135,100.5393,82.353553L94.247,88.64589L94.2459,88.647L74.646447,108.2464Q74.57612,108.3168,74.53806,108.4087Q74.5,108.5005,74.5,108.6L74.5,117Q74.5,117.0492,74.509607,117.0975Q74.519215,117.14580000000001,74.53806,117.1913Q74.556906,117.2368,74.584265,117.2778Q74.611625,117.3187,74.646447,117.3535Q74.681269,117.38839999999999,74.722215,117.4157Q74.763161,117.4431,74.808658,117.4619Q74.854155,117.4808,74.9024549,117.4904Q74.9507543,117.5,75,117.5L83.4,117.5Q83.49946,117.5,83.59134,117.4619Q83.68323,117.4239,83.75355,117.3536ZM94.6,89.70711L75.5,108.80709999999999L75.5,116.5L83.19289,116.5L102.2929,97.4L94.6,89.70711ZM95.30709999999999,89L103,96.6929L108.9393,90.75355Q109.0858,90.60711,109.0858,90.4Q109.0858,90.19289,108.9393,90.04645L101.9536,83.06066Q101.80709999999999,82.914214,101.6,82.914214Q101.3929,82.914214,101.2464,83.06066L95.30709999999999,89Z",
    fillRule: "evenodd",
    fill: "#2BA9DE",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceBound);
export default __webpack_public_path__ + "static/media/DeviceBound.c9807c89f2d8128b414e1b0a6eaa4c77.svg";
export { ForwardRef as ReactComponent };